  <template>
    <div
      class="h-screen overflow-y-auto bg-gray-50 pb-24 referred-page"
      id="referred"
    >
      <div class="mx-auto">
        <!-- Header Section (sticky) -->
        <div class="sticky top-0 z-20 bg-gray-50 px-4 pt-6 pb-4 mb-2">
          <!-- Desktop Layout: All elements in one line -->
          <div class="hidden md:flex gap-4 items-end">
            <div class="flex-1">
              <div class="choose-select">
                <select
                  v-model="selected_post"
                  class="plain-select"
                >
                  <option value="" disabled>{{ $t('select') }}</option>
                  <option v-for="item in post_items" :key="item.value" :value="item.value">
                    {{ item.label }}
                  </option>
                </select>
              </div>
            </div>
            <div class="flex-1">
              <div class="choose-select">
                <select
                  v-model="selected_request_type"
                  class="plain-select"
                >
                  <option
                    v-for="item in request_type_items"
                    :key="'type-' + item.value"
                    :value="item.value"
                  >
                    {{ item.label }}
                  </option>
                </select>
              </div>
            </div>
            <div class="flex-1">
              <div class="input-group" data-label="جستجو">
                <input
                  type="text"
                  placeholder="جستجو در درخواست‌ها..."
                  v-model="search_list"
                  class="input"
                />
                <img src="/img/svg/search.svg" alt="search" class="search-icon w-4 h-4">
                             </div>
            </div>
            <div class="w-14">
              <button 
                @click="dialog_barcode=true,barcode_rec_id='',barcode_rec_code=''"
                class="w-full h-14 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-xl flex items-center justify-center hover:from-blue-600 hover:to-blue-700 transition-all duration-200 hover:shadow-xl transform hover:-translate-y-0.5"
              >
                <img src="/img/svg/code-scan.svg" class="w-10 h-10" alt="بارکد اسکنر" />
              </button>
            </div>
          </div>

          <!-- Mobile Layout: Search full width + filter button -->
          <div class="md:hidden referred-mobile-toolbar flex gap-2 items-center">
            <div class="flex-1 min-w-0">
              <div class="input-group referred-mobile-search">
                <img src="/img/svg/search.svg" alt="search" class="input-icon w-4 h-4">
                <input
                  type="text"
                  placeholder="جستجو در درخواست‌ها..."
                  v-model="search_list"
                  class="input"
                />
              </div>
            </div>
            <button
              type="button"
              @click="mobile_filter_open = true"
              :class="mobileFilterActive ? 'border-blue-500 bg-blue-50 text-blue-600' : 'border-gray-200 bg-white text-gray-600'"
              class="referred-mobile-filter-btn flex-shrink-0 border rounded-xl flex items-center justify-center transition-colors"
              aria-label="فیلتر"
            >
              <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.382a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 2v-6.586a1 1 0 00-.293-.707L3.293 7.09A1 1 0 013 6.382V4z" />
              </svg>
            </button>
          </div>
        </div>

      <!-- Request Cards -->
      <div class="px-4">
      <div v-if="pageLoading" class="referred-skeleton-group" aria-hidden="true">
        <div class="hidden md:grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
          <div
            v-for="n in skeletonCardCount"
            :key="'referred-sk-d-' + n"
            class="skeleton-block skeleton-req-card"
          ></div>
        </div>
        <div class="md:hidden space-y-5">
          <div
            v-for="n in skeletonCardCount"
            :key="'referred-sk-m-' + n"
            class="skeleton-block skeleton-req-card"
          ></div>
        </div>
      </div>

      <!-- Desktop Grid Layout -->
      <div v-if="!pageLoading" class="hidden md:grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 items-stretch">
        <div class="req-card bg-white border border-gray-150 rounded-xl flex flex-col h-full transition-all duration-200 hover:shadow-md hover:-translate-y-0.5 overflow-hidden" v-for="item in request_items_filtered" :id="item.Id" :key="item.Id">
          <div class="p-4 flex-1 min-h-0">
            <div @click="goToDetail(item)" class="w-full cursor-pointer">
              <div class="flex items-center mb-2 gap-2">
                <span
                  v-if="item.IsFinalize == 1"
                  @click.stop="go_to_attachment(item)"
                  class="req-attachment-btn inline-flex w-fit max-w-fit flex-shrink-0 px-2 py-1 gap-1.5 border border-gray-300 items-center bg-gray-100 text-xs rounded-lg cursor-pointer hover:bg-gray-200 transition-colors"
                >
                  <span>پیوست</span>
                  <svg class="req-info-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
                  </svg>
                </span>
                <div class="req-date mr-auto text-xs text-gray-500">
                  {{ item.ReqReceivDate }}
                </div>
              </div>

              <!-- Request Header -->
              <div class="flex items-start justify-between mb-3">
                <div class="flex-1">
                  <h3 class="req-name text-sm font-medium text-gray-800 mb-2 leading-tight">
                    {{ item.RequestName }}
                  </h3>
                
                </div>
                              
              </div>

              <!-- Status -->
              <div class="flex items-center justify-between mb-3">
                <div
                  class="status px-3 py-1 text-xs font-medium rounded-full"
                  :class="ejraiStatusClass(item)"
                  :style="ejraiStatusStyle(item)"
                  :title="ejraiStatusTitle(item)"
                >
                  <span>{{ formatEjraiStatus(item.StatusNameEjrai) }}</span>
                  <span v-if="getEjraiStatusSubmitTime(item)" class="status-time">
                    {{ getEjraiStatusSubmitTime(item) }}
                  </span>
                </div>
              </div>

                <!-- Address -->
                <div v-if="has_request_address(item)" class="address text-sm text-gray-600 flex items-center gap-2">
                <svg class="req-info-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                {{get_request_address(item)}}
              </div>

              <!-- Tags -->
              <div class="flex flex-wrap gap-2 mt-3">
                <span v-for="item_chip in item.PredefinedGlobal" :key="item_chip.Text"
                      class="inline-block bg-blue-50 text-blue-700 text-xs px-3 py-1 rounded-lg border border-blue-200"
                >
                  {{item_chip.Text}}:{{item_chip.Value}}
                </span>
                <span v-for="item_chip in item.PredefinedChecked" :key="item_chip.Text"
                      class="inline-block bg-blue-50 text-blue-700 text-xs px-3 py-1 rounded-lg border border-blue-200"
                >
                  {{item_chip.Text}}:{{item_chip.Value}}
                </span>
              </div>
            </div>
          </div>

          <div class="req-card-footer flex mt-auto flex-shrink-0 w-full overflow-hidden border-t border-gray-100">
            <div class="req-card-footer__code w-1/2 bg-blue-50 text-xs font-bold text-blue-800 truncate">
              {{ item.RequestCode }}
            </div>
            <a
              v-if="getCustomerMobile(item)"
              :href="'tel:' + getCustomerMobile(item)"
              @click.stop
              class="req-card-footer__phone w-1/2 bg-green-50 text-xs font-bold text-green-800 truncate"
            >
              {{ getCustomerMobile(item) }}
            </a>
            <div
              v-else
              class="req-card-footer__phone w-1/2 bg-green-50 text-xs text-green-700 text-opacity-50 truncate"
            >
              —
            </div>
          </div>
        </div>
      </div>

      <!-- Mobile Stack Layout -->
      <div v-if="!pageLoading" class="md:hidden space-y-5">
        <div class="req-card bg-white border border-gray-150 rounded-xl flex flex-col h-full transition-all duration-200 hover:shadow-md hover:-translate-y-0.5 overflow-hidden" v-for="item in request_items_filtered" :id="item.Id" :key="item.Id">
          <div class="p-4 flex-1 min-h-0">
            <div @click="goToDetail(item)" class="w-full cursor-pointer">
              <div class="flex items-center mb-2 gap-2">
                <span
                  v-if="item.IsFinalize == 1"
                  @click.stop="go_to_attachment(item)"
                  class="req-attachment-btn inline-flex w-fit max-w-fit flex-shrink-0 px-2 py-1 gap-1.5 border border-gray-300 items-center bg-gray-100 text-xs rounded-lg cursor-pointer hover:bg-gray-200 transition-colors"
                >
                  <span>پیوست</span>
                  <svg class="req-info-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.172 7l-6.586 6.586a2 2 0 102.828 2.828l6.414-6.586a4 4 0 00-5.656-5.656l-6.415 6.585a6 6 0 108.486 8.486L20.5 13" />
                  </svg>
                </span>
                <div class="req-date mr-auto text-xs text-gray-500">
                  {{ item.ReqReceivDate }}
                </div>
              </div>
              
              <!-- Request Header -->
              <div class="flex items-start justify-between mb-3">
                <div class="flex-1">
                  <h3 class="req-name font-medium text-gray-800 mb-2 leading-tight">
                    {{ item.RequestName }}
                  </h3>
                 
                </div>
                
              </div>

              <!-- Status -->
              <div class="flex items-center justify-between mb-3">
                <div
                  class="status px-3 py-1 text-xs font-medium rounded-full"
                  :class="ejraiStatusClass(item)"
                  :style="ejraiStatusStyle(item)"
                  :title="ejraiStatusTitle(item)"
                >
                  <span>{{ formatEjraiStatus(item.StatusNameEjrai) }}</span>
                  <span v-if="getEjraiStatusSubmitTime(item)" class="status-time">
                    {{ getEjraiStatusSubmitTime(item) }}
                  </span>
                </div>
              </div>

              <!-- Address -->
              <div v-if="has_request_address(item)" class="address text-sm text-gray-600 flex items-center gap-2">
                <svg class="req-info-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                </svg>
                {{get_request_address(item)}}
              </div>

              <!-- Tags -->
              <div class="flex flex-wrap gap-2 mt-3">
                <span v-for="item_chip in item.PredefinedGlobal" :key="item_chip.Text"
                      class="inline-block bg-blue-50 text-blue-700 text-xs px-3 py-1 rounded-lg border border-blue-200"
                >
                  {{item_chip.Text}}:{{item_chip.Value}}
                </span>
                <span v-for="item_chip in item.PredefinedChecked" :key="item_chip.Text"
                      class="inline-block bg-blue-50 text-blue-700 text-xs px-3 py-1 rounded-lg border border-blue-200"
                >
                  {{item_chip.Text}}:{{item_chip.Value}}
                </span>
              </div>
            </div>
          </div>

          <div class="req-card-footer flex mt-auto flex-shrink-0 w-full overflow-hidden border-t border-gray-100">
            <div class="req-card-footer__code w-1/2 bg-blue-50 text-xs font-bold text-blue-800 truncate">
              {{ item.RequestCode }}
            </div>
            <a
              v-if="getCustomerMobile(item)"
              :href="'tel:' + getCustomerMobile(item)"
              @click.stop
              class="req-card-footer__phone w-1/2 bg-green-50 text-xs font-bold text-green-800 truncate"
            >
              {{ getCustomerMobile(item) }}
            </a>
            <div
              v-else
              class="req-card-footer__phone w-1/2 bg-green-50 text-xs text-green-700 text-opacity-50 truncate"
            >
              —
            </div>
          </div>
        </div>
      </div>
      </div>

    </div>

    <div
      v-if="lightbox_image"
      class="request-lightbox fixed inset-0 bg-black bg-opacity-80 pt-4 pb-24 px-4 flex items-center justify-center overflow-hidden"
      @click="on_lightbox_backdrop_click($event)"
      @wheel.prevent="on_lightbox_wheel($event)"
      @touchstart="on_lightbox_touch_start($event)"
      @touchmove="on_lightbox_touch_move($event)"
      @touchend="on_lightbox_touch_end($event)"
    >
      <button
        v-if="attachment_items.length > 1"
        type="button"
        class="absolute left-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white bg-opacity-20 hover:bg-white hover:bg-opacity-30 text-white text-2xl z-10"
        @click.stop="show_prev_image()"
      >
        ›
      </button>
      <button
        v-if="attachment_items.length > 1"
        type="button"
        class="absolute right-3 top-1/2 -translate-y-1/2 w-10 h-10 rounded-full bg-white bg-opacity-20 hover:bg-white hover:bg-opacity-30 text-white text-2xl z-10"
        @click.stop="show_next_image()"
      >
        ‹
      </button>
      <button
        type="button"
        class="absolute top-4 right-4 w-10 h-10 rounded-full bg-white bg-opacity-20 hover:bg-white hover:bg-opacity-30 text-white text-xl"
        @click.stop="close_lightbox()"
      >
        ×
      </button>
      <div class="request-lightbox__stage flex items-center justify-center max-w-full" @click.stop>
        <img
          :src="lightbox_image"
          class="request-lightbox__img max-w-full object-contain rounded-lg select-none"
          :style="lightbox_image_style()"
          draggable="false"
          @click.stop="on_lightbox_image_click()"
        />
      </div>
    </div>

    <!-- Mobile Filters -->
    <div v-if="mobile_filter_open" class="referred-mobile-filter-overlay fixed inset-0 md:hidden">
      <div class="absolute inset-0 bg-black bg-opacity-50" @click="mobile_filter_open = false"></div>
      <div class="referred-mobile-filter-sheet absolute bottom-0 left-0 right-0 bg-white rounded-t-2xl shadow-xl overflow-hidden">
        <div class="flex items-center justify-between px-5 py-4 border-b border-gray-200">
          <h3 class="text-base font-bold text-gray-800">فیلترها</h3>
          <button
            type="button"
            @click="mobile_filter_open = false"
            class="p-1 hover:bg-gray-100 rounded-lg transition-colors"
            aria-label="بستن"
          >
            <svg class="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        <div class="referred-mobile-filter-tabs grid grid-cols-2 border-b border-gray-200" dir="ltr">
          <button
            type="button"
            @click="mobile_filter_tab = 'status'"
            :class="mobile_filter_tab === 'status'
              ? 'text-blue-600 border-blue-600'
              : 'text-gray-500 border-transparent'"
            class="py-3 text-sm font-semibold border-b-2 transition-colors"
          >
            وضعیت
          </button>
          <button
            type="button"
            @click="mobile_filter_tab = 'branch'"
            :class="mobile_filter_tab === 'branch'
              ? 'text-blue-600 border-blue-600'
              : 'text-gray-500 border-transparent'"
            class="py-3 text-sm font-semibold border-b-2 transition-colors"
          >
            شعبه
          </button>
        </div>

        <div class="referred-mobile-filter-list max-h-60vh overflow-y-auto px-4 py-3">
          <template v-if="mobile_filter_tab === 'status'">
            <button
              v-for="item in request_type_items"
              :key="'mobile-type-' + item.value"
              type="button"
              @click="selectMobileRequestType(item.value)"
              :class="selected_request_type === item.value
                ? 'border-blue-500 bg-blue-50 text-blue-700'
                : 'border-gray-200 bg-white text-gray-800 hover:bg-gray-50'"
              class="w-full mb-2 px-4 py-3 rounded-xl border text-right text-sm font-medium transition-colors"
            >
              {{ item.label }}
            </button>
          </template>
          <template v-else>
            <button
              v-for="item in post_items"
              :key="'mobile-post-' + item.value"
              type="button"
              @click="selectMobilePost(item.value)"
              :class="selected_post === item.value
                ? 'border-blue-500 bg-blue-50 text-blue-700'
                : 'border-gray-200 bg-white text-gray-800 hover:bg-gray-50'"
              class="w-full mb-2 px-4 py-3 rounded-xl border text-right text-sm font-medium transition-colors"
            >
              {{ item.label }}
            </button>
          </template>
        </div>
      </div>
    </div>

    <!-- Barcode Dialog -->
    <div v-if="dialog_barcode" class="fixed inset-0 z-999">
      <div class="absolute inset-0 bg-black bg-opacity-60" @click="dialog_barcode = false"></div>
      <div class="relative z-10 flex h-full w-full items-center justify-center p-4">
        <div class="w-full max-w-sm bg-white border border-gray-200 rounded-2xl shadow-xl overflow-hidden">
          <!-- Header -->
          <div class="flex items-center justify-between px-6 py-4 border-b border-gray-200">
            <h3 class="text-lg font-semibold text-gray-800">{{ $t('barcode_reader') }}</h3>
            <button @click="dialog_barcode = false" class="p-1 hover:bg-gray-100 rounded-lg transition-colors">
              <svg class="w-5 h-5 text-gray-500" fill="currentColor" viewBox="0 0 24 24">
                <path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
          
          <!-- Content -->
          <div class="p-6">
            <div class="text-center mb-4">
              <div class="text-sm text-gray-600 bg-gray-50 rounded-lg p-3 font-mono">{{barcode_rec_code}}</div>
            </div>
            
            <div class="mb-6">
              <QrcodeStream @decode="onDecodeBarcode"></QrcodeStream>
            </div>
          </div>
          
          <!-- Actions -->
          <div class="flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-200 bg-gray-50">
            <button
              @click="dialog_barcode = false"
              class="px-4 py-2 text-gray-600 hover:text-gray-800 transition-colors text-sm font-medium"
            >
              {{$t('cancel')}}
            </button>
            <button
              v-if="barcode_rec_id!=0"
              @click="goToDetail_barcode()"
              class="px-6 py-2 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-lg hover:from-blue-600 hover:to-blue-700 transition-all duration-200 text-sm font-medium hover:shadow-xl transform hover:-translate-y-0.5"
            >
              {{ $t('show_request') }}
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading'
  import {QrcodeStream, QrcodeDropZone, QrcodeCapture} from 'vue-qrcode-reader'
  import {bus} from '../../main.js'
  import { skeletonSilentRequest } from '../../utils/skeletonPages'

  export default {
    props: [
      'passing_data'
    ],

    data() {
      return {
        list: [],
        errors: [],
        post_items: [],
        selected_post: null,
        selected_branch: 0,
        selected_request_type: 'all',
        request_type_items: [
          { label: 'همه', value: 'all' },
          { label: 'درخواست', value: 'request' },
          { label: 'پیش درخواست', value: 'pre_request' },
        ],
        search_list: "",
        request_items: [],
        request_items_filtered: [],
        last_request_items: [],
        show_loading: false,
        no_info: true,
        first_load: true,
        page: 0,
        dialog_barcode: false,
        first: true,
        barcode_rec_id: '',
        barcode_rec_code: '',
        attachment_items: [],
        lightbox_image: '',
        lightbox_index: -1,
        lightbox_scale: 1,
        lightbox_translate_x: 0,
        lightbox_translate_y: 0,
        lightbox_touch_mode: '',
        lightbox_touch_start_x: 0,
        lightbox_pinch_start_distance: 0,
        lightbox_pinch_start_scale: 1,
        lightbox_pan_start_x: 0,
        lightbox_pan_start_y: 0,
        lightbox_pan_origin_tx: 0,
        lightbox_pan_origin_ty: 0,
        pageLoading: true,
        skeletonCardCount: 8,
        mobile_filter_open: false,
        mobile_filter_tab: 'status',
      }
    },
    components: {
      InfiniteLoading,
      QrcodeStream: QrcodeStream,
      QrcodeDropZone,
      QrcodeCapture,
    },
    computed: {
      mobileFilterActive () {
        var postActive = this.selected_post !== null && this.selected_post !== '' && this.selected_post !== 0
        var typeActive = this.selected_request_type && this.selected_request_type !== 'all'
        return postActive || typeActive
      },
    },
    watch: {
      search_list: function(){
        this.applyListFilters()
      },
      selected_request_type: function () {
        this.applyListFilters()
      },
      selected_post: function (val) {
      if(this.first_load==false){
        this.page = 0
        this.request_items = []
        this.no_info = false
        this.get_branch_by_post()
        this.show_loading = true
        localStorage.setItem('selected_post', this.selected_post)
      }

      }
    },
    mounted() {
      this.get_posts()

    },

    methods: {
      matchesRequestType (item) {
        if (!item) return false
        if (this.selected_request_type === 'request') return item.IsFinalize == 1
        if (this.selected_request_type === 'pre_request') return item.IsFinalize != 1
        return true
      },
      matchesSearch (item) {
        var q = String(this.search_list || '').trim()
        if (!q) return true
        var name = item && item.RequestName != null ? String(item.RequestName) : ''
        var code = item && item.RequestCode != null ? String(item.RequestCode) : ''
        return name.includes(q) || code.includes(q)
      },
      applyListFilters () {
        var self = this
        this.request_items_filtered = (this.request_items || []).filter(function (val) {
          return self.matchesRequestType(val) && self.matchesSearch(val)
        })
        this.$forceUpdate()
      },
      selectMobilePost (value) {
        this.selected_post = value
        this.mobile_filter_open = false
      },
      selectMobileRequestType (value) {
        this.selected_request_type = value
        this.mobile_filter_open = false
      },
      finishInitialLoad () {
        if (this.pageLoading) {
          this.pageLoading = false
        }
      },
      goToDetail(item) {
        localStorage.setItem("refered_scroll_position", document.getElementById("referred").scrollTop);
    // console.log(document.getElementById("referred").scrollTop)
        if (item.IsFinalize == 1) {
          this.$router.push({name: 'ViewRequest', params: {rec_id: item.Id}})
        } else {
          this.$router.push({name: 'ViewPreRequest', params: {rec_id: item.Id}})
        }
      },
      goToDetail_barcode() {
        // var passing_data = JSON.parse(localStorage.getItem('request_data'));
        // passing_data.cat_id = item_id;
        // localStorage.setItem("request_data",JSON.stringify(passing_data));
        this.$router.push({path: '/report-request/view-request/' + this.barcode_rec_id})
      },
      go_to_attachment(item) {
        if (item.IsFinalize == 1) {
          this.get_attachs(item.Id, true)
        }
      },
      get_attachs(req_id, openLightbox = false) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          ReqId: req_id,
          IsFinalize: 1,
        }
        this.axios.post('/GetUserRequestImages', send_data, skeletonSilentRequest)
          .then(response => {
            if (response.data.error == 0) {
              self.attachment_items = response.data.results || [];
              self.attachment_items.forEach(function(attach) {
                if (attach.ImagePath && !attach.ImagePath.startsWith('http')) {
                  attach.ImagePath = 'https://' + attach.ImagePath;
                }
              });
              if (openLightbox && self.attachment_items.length) {
                self.open_image(0)
              }
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      open_image(index) {
        if (!this.attachment_items.length) return
        this.lightbox_index = index
        this.lightbox_image = this.attachment_items[index].ImagePath
        this.reset_lightbox_zoom()
      },
      close_lightbox() {
        this.lightbox_image = ''
        this.lightbox_index = -1
        this.reset_lightbox_zoom()
      },
      show_next_image() {
        if (!this.attachment_items.length) return
        this.lightbox_index = (this.lightbox_index + 1) % this.attachment_items.length
        this.lightbox_image = this.attachment_items[this.lightbox_index].ImagePath
        this.reset_lightbox_zoom()
      },
      show_prev_image() {
        if (!this.attachment_items.length) return
        this.lightbox_index = (this.lightbox_index - 1 + this.attachment_items.length) % this.attachment_items.length
        this.lightbox_image = this.attachment_items[this.lightbox_index].ImagePath
        this.reset_lightbox_zoom()
      },
      reset_lightbox_zoom() {
        this.lightbox_scale = 1
        this.lightbox_translate_x = 0
        this.lightbox_translate_y = 0
        this.lightbox_touch_mode = ''
      },
      lightbox_image_style() {
        const scale = this.lightbox_scale
        const tx = this.lightbox_translate_x
        const ty = this.lightbox_translate_y
        const base = {
          maxHeight: 'calc(100vh - 8rem)',
          transition: this.lightbox_touch_mode ? 'none' : 'transform 0.15s ease'
        }
        if (scale <= 1 && tx === 0 && ty === 0) {
          return { ...base, cursor: 'zoom-in' }
        }
        return {
          ...base,
          maxHeight: 'none',
          transform: `translate(${tx}px, ${ty}px) scale(${scale})`,
          transformOrigin: 'center center',
          cursor: this.lightbox_touch_mode === 'pan' ? 'grabbing' : 'grab'
        }
      },
      clamp_lightbox_scale(scale) {
        return Math.min(4, Math.max(1, scale))
      },
      set_lightbox_scale(scale) {
        const clamped = this.clamp_lightbox_scale(scale)
        if (clamped <= 1) {
          this.reset_lightbox_zoom()
          return
        }
        this.lightbox_scale = clamped
      },
      get_touch_distance(touches) {
        const dx = touches[0].clientX - touches[1].clientX
        const dy = touches[0].clientY - touches[1].clientY
        return Math.hypot(dx, dy)
      },
      on_lightbox_wheel(e) {
        if (!this.lightbox_image) return
        const step = e.deltaY < 0 ? 0.15 : -0.15
        this.set_lightbox_scale(this.lightbox_scale + step)
      },
      on_lightbox_backdrop_click(e) {
        if (e.target === e.currentTarget) {
          this.close_lightbox()
        }
      },
      on_lightbox_image_click() {
        if (this.lightbox_scale > 1) {
          this.reset_lightbox_zoom()
        } else {
          this.set_lightbox_scale(2)
        }
      },
      on_lightbox_touch_start(e) {
        if (e.touches.length === 2) {
          this.lightbox_touch_mode = 'pinch'
          this.lightbox_pinch_start_distance = this.get_touch_distance(e.touches)
          this.lightbox_pinch_start_scale = this.lightbox_scale
          return
        }
        if (e.touches.length !== 1) return
        if (this.lightbox_scale > 1) {
          this.lightbox_touch_mode = 'pan'
          this.lightbox_pan_start_x = e.touches[0].clientX
          this.lightbox_pan_start_y = e.touches[0].clientY
          this.lightbox_pan_origin_tx = this.lightbox_translate_x
          this.lightbox_pan_origin_ty = this.lightbox_translate_y
          return
        }
        this.lightbox_touch_mode = 'swipe'
        this.lightbox_touch_start_x = e.touches[0].clientX
      },
      on_lightbox_touch_move(e) {
        if (this.lightbox_touch_mode === 'pinch' && e.touches.length === 2) {
          e.preventDefault()
          const dist = this.get_touch_distance(e.touches)
          if (!this.lightbox_pinch_start_distance) return
          const ratio = dist / this.lightbox_pinch_start_distance
          this.set_lightbox_scale(this.lightbox_pinch_start_scale * ratio)
          return
        }
        if (this.lightbox_touch_mode === 'pan' && e.touches.length === 1) {
          e.preventDefault()
          const dx = e.touches[0].clientX - this.lightbox_pan_start_x
          const dy = e.touches[0].clientY - this.lightbox_pan_start_y
          this.lightbox_translate_x = this.lightbox_pan_origin_tx + dx
          this.lightbox_translate_y = this.lightbox_pan_origin_ty + dy
        }
      },
      on_lightbox_touch_end(e) {
        if (this.lightbox_touch_mode === 'pinch' || this.lightbox_touch_mode === 'pan') {
          if (!e.touches.length) {
            this.lightbox_touch_mode = ''
            if (this.lightbox_scale < 1.05) {
              this.reset_lightbox_zoom()
            }
          }
          return
        }
        if (this.lightbox_touch_mode !== 'swipe') return
        if (!e.changedTouches || !e.changedTouches.length) return
        this.lightbox_touch_mode = ''
        if (this.lightbox_scale > 1 || this.attachment_items.length <= 1) return
        const delta_x = e.changedTouches[0].clientX - this.lightbox_touch_start_x
        const swipe_threshold = 40
        if (Math.abs(delta_x) < swipe_threshold) return
        if (delta_x < 0) {
          this.show_next_image()
        } else {
          this.show_prev_image()
        }
      },
      onDecodeBarcode(decodedString) {
        var self = this
        const send_data = {
          ReqCode: decodedString,
        }
        this.barcode_rec_code = decodedString;
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetReqInfoByReqCode', send_data, skeletonSilentRequest)
          .then(response => {
            if (response.data.error == 0) {
              // bus.$emit('show_toast', [2000, response.data])

              self.barcode_rec_id = response.data.ReqId;
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },
      get_request_address(item) {
        var address = ''
        if (item.CityName != null) {
          address += item.CityName + ' '
        }
        if (item.AreaName != null) {
          address += item.AreaName + ' '
        }
        return address.trim()
      },
      has_request_address(item) {
        return this.get_request_address(item).length > 0
      },
      hasEjraiStatusColor(item) {
        const color = item && item.StatusNameColor
        return color != null && String(color).trim() !== ''
      },
      ejraiStatusClass(item) {
        return this.hasEjraiStatusColor(item) ? '' : 'bg-yellow-100 text-yellow-800'
      },
      parseStatusColorRgb(color) {
        const value = String(color).trim()
        const hexMatch = value.match(/^#?([0-9a-f]{3}|[0-9a-f]{6})$/i)
        if (hexMatch) {
          let hex = hexMatch[1]
          if (hex.length === 3) {
            hex = hex.split('').map((c) => c + c).join('')
          }
          const num = parseInt(hex, 16)
          return {
            r: (num >> 16) & 255,
            g: (num >> 8) & 255,
            b: num & 255,
          }
        }
        const rgbMatch = value.match(/^rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i)
        if (rgbMatch) {
          return {
            r: Number(rgbMatch[1]),
            g: Number(rgbMatch[2]),
            b: Number(rgbMatch[3]),
          }
        }
        return null
      },
      lightenStatusColor(color, amount = 0.5) {
        const rgb = this.parseStatusColorRgb(color)
        if (!rgb) {
          return color
        }
        const mix = (channel) => Math.round(channel + (255 - channel) * amount)
        return `rgb(${mix(rgb.r)}, ${mix(rgb.g)}, ${mix(rgb.b)})`
      },
      ejraiStatusStyle(item) {
        if (!this.hasEjraiStatusColor(item)) {
          return {}
        }
        const color = String(item.StatusNameColor).trim()
        return {
          color,
          backgroundColor: this.lightenStatusColor(color, 0.85),
        }
      },
      formatEjraiStatus(text) {
        if (text == null) {
          return ''
        }
        const value = String(text)
        return value.length > 150 ? value.slice(0, 150) + '...' : value
      },
      isEjraiStatusTruncated(text) {
        return text != null && String(text).length > 150
      },
      parseEjraiStatusSummary (item) {
        if (!item) return []
        var raw = item.EjraiStatusSummary
        if (!raw) return []
        if (Array.isArray(raw)) return raw
        try {
          var parsed = typeof raw === 'string' ? JSON.parse(raw) : raw
          return Array.isArray(parsed) ? parsed : []
        } catch (e) {
          return []
        }
      },
      normalizeEjraiStatusName (name) {
        return String(name || '').trim().replace(/_+$/g, '').trim()
      },
      getLatestEjraiStatus (item) {
        var list = this.parseEjraiStatusSummary(item)
        if (!list.length) return null
        var statusName = this.normalizeEjraiStatusName(item && item.StatusNameEjrai)
        if (statusName) {
          for (var i = list.length - 1; i >= 0; i--) {
            if (list[i] && this.normalizeEjraiStatusName(list[i].StatusName) === statusName) {
              return list[i]
            }
          }
        }
        return list[list.length - 1]
      },
      formatEjraiSubmitTime (submitTime) {
        if (submitTime == null || String(submitTime).trim() === '') return ''
        // نمونه: "25-04-2026 05 56" → "25-04-2026 05:56"
        var value = String(submitTime).trim().replace(/\s+/g, ' ')
        var match = value.match(/^(\d{1,2}-\d{1,2}-\d{4})\s+(\d{1,2})\s+(\d{1,2})$/)
        if (match) {
          var hh = match[2].length === 1 ? '0' + match[2] : match[2]
          var mm = match[3].length === 1 ? '0' + match[3] : match[3]
          return match[1] + ' ' + hh + ':' + mm
        }
        return value
      },
      getEjraiStatusSubmitTime (item) {
        var latest = this.getLatestEjraiStatus(item)
        return latest ? this.formatEjraiSubmitTime(latest.SubmitTime) : ''
      },
      ejraiStatusTitle (item) {
        var name = item && item.StatusNameEjrai != null ? String(item.StatusNameEjrai) : ''
        var time = this.getEjraiStatusSubmitTime(item)
        var full = time ? (name + ' — ' + time) : name
        return full || undefined
      },
      getCustomerMobile(item) {
        var mobile = item && (item.CostomerMobile || item.CustomerMobile)
        if (mobile == null) return ''
        mobile = String(mobile).trim().replace(/\s+/g, '')
        if (!mobile) return ''
        // اگر با 98 شروع شده، به 0 تبدیل کن
        if (mobile.indexOf('+98') === 0) {
          mobile = '0' + mobile.slice(3)
        } else if (mobile.indexOf('98') === 0 && mobile.length >= 12) {
          mobile = '0' + mobile.slice(2)
        }
        // اگر بدون صفر اول آمده، صفر اضافه کن
        if (mobile.charAt(0) !== '0') {
          mobile = '0' + mobile
        }
        return mobile
      },
      get_branch_by_post() {
        var self = this
        const send_data = {
          PartyId: this.selected_post,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetBranchIdByPartyId', send_data, skeletonSilentRequest)
          .then(response => {
            if (response.data.error == 0) {
              // console.log("response", response);
              // self.user_registered = true;
              // self.fullName = response.data.msg;
              // self.level = 2;

              self.selected_branch = response.data.branchId
              self.first_load = false;
              self.get_pre_requests(null)
            } else {
              self.finishInitialLoad()
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
          self.finishInitialLoad()
        })
      },
      get_posts() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        console.log()
        const send_data = {
          UserId: user_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetUserParties', send_data, skeletonSilentRequest)
          .then(response => {
            if (response.data.error == 0) {
              response.data.parties.forEach(function (number) {
                if(number.Id==0){
                  number.PartyName="همه شعب"
                }
                var obj = {label: number.PartyName, value: number.Id}
                self.post_items.push(obj)
              })
              if (self.post_items.length == 2) {
                console.log('self.post_items[1]', self.post_items[1])
                // self.selected_post = self.post_items[1].value
              }
              // console.log(localStorage.getItem('selected_post'))
              self.selected_post =0
              self.page = 0
              self.request_items = []
              self.no_info = false
              self.get_branch_by_post()
              self.show_loading = true
              localStorage.setItem('selected_post', self.selected_post)
            } else {
              self.finishInitialLoad()
            }
          }).catch(e => {
          this.errors.push(e)
          self.finishInitialLoad()
        })
      },
      get_pre_requests() {
        // this.request_items = [];
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          IsDriver: 0,
          Count: this.page,
          BranchId: this.selected_branch,
        }

        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetPreRequestsByUserId', send_data, skeletonSilentRequest)
          .then(response => {
            self.last_request_items = []
            if (response.data.error == 0) {
              response.data.requests.forEach(function (number) {
                self.request_items.push(number)
              })
              self.last_request_items = response.data.requests
              self.list = response.data.requests
              self.get_final_requests(response.data.requests.length)
            } else {
              self.finishInitialLoad()
            }
          }).catch(e => {
          this.errors.push(e)
          self.finishInitialLoad()
        })
      },
      get_final_requests(last_size) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          ExpertId: user_id,
          IsDriver: 0,
          BranchId: this.selected_branch,
          Count: this.page,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetUserDevicesByExpertId', send_data, skeletonSilentRequest)
          .then(response => {
            if (response.data.error == 0) {
              response.data.requests.forEach(function (number) {

                // if(number.RequestCode.includes('R401_30299')){
                //   console.log("R found R401_30299",self.page,number);
                // }
                if(self.request_items.filter(x => x.RequestCode==number.RequestCode).length==0){
                  self.request_items.push(number)
                  self.last_request_items.push(number)
                }else{
                  console.log("dupplicate found")
                }

              })
              if (self.first) {
                self.first = false
              }
              if (last_size != 0 || response.data.requests.length != 0) {
                self.page++;
                self.get_pre_requests();
              } else {

                self.applyListFilters()
                self.finishInitialLoad()
                var scroll = localStorage.getItem("refered_scroll_position");

                if (scroll != null) {
                  setTimeout(() => {
                    document.getElementById("referred").scrollTop = scroll;
                  }, 500)
                }
              }

            } else {
              self.finishInitialLoad()
            }
          }).catch(e => {
          this.errors.push(e)
          self.finishInitialLoad()
        })
      },
    }
  }
</script>
<style scoped>
  .req-info-icon {
    width: 1rem;
    height: 1rem;
    flex-shrink: 0;
    color: #6b7280;
  }

  .status {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 2px;
    max-width: 100%;
    line-height: 1.35;
  }

  .status-time {
    font-size: 10px;
    font-weight: 500;
    opacity: 0.85;
    direction: ltr;
    unicode-bidi: plaintext;
  }

  .referred-mobile-toolbar .referred-mobile-search {
    min-height: 3.5rem;
    padding: 0 0.75rem 0 2.25rem;
  }

  .referred-mobile-toolbar .referred-mobile-search .input {
    font-size: 0.875rem;
  }

  .referred-mobile-toolbar .referred-mobile-search .input-icon {
    width: 1rem;
    height: 1rem;
    left: 0.75rem;
  }

  .referred-mobile-toolbar .referred-mobile-filter-btn {
    width: 3.5rem;
    height: 3.5rem;
    min-width: 3.5rem;
    max-width: 3.5rem;
    padding: 0;
    aspect-ratio: 1 / 1;
    box-sizing: border-box;
  }

  .referred-mobile-filter-overlay {
    z-index: 999;
  }

  .referred-mobile-filter-list {
    padding-bottom: calc(0.75rem + env(safe-area-inset-bottom, 0px));
  }

  .req-attachment-btn {
    width: fit-content;
    max-width: max-content;
  }

  .req-card-footer {
    width: 100%;
    height: 45px;
    max-height: 45px;
    box-sizing: border-box;
  }

  .req-card-footer__code,
  .req-card-footer__phone {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 0 0.375rem;
    min-width: 0;
    box-sizing: border-box;
  }

  .req-card-footer__phone {
    border-inline-end: 1px solid rgba(226, 232, 240, 0.9);
  }

  .referred-skeleton-group {
    position: relative;
    overflow: hidden;
    pointer-events: none;
    user-select: none;
  }

  .referred-skeleton-group::after {
    content: '';
    position: absolute;
    inset: 0;
    z-index: 1;
    pointer-events: none;
    transform: translateX(-100%);
    background: linear-gradient(
      90deg,
      rgba(255, 255, 255, 0) 0%,
      rgba(255, 255, 255, 0.55) 45%,
      rgba(255, 255, 255, 0.65) 55%,
      rgba(255, 255, 255, 0) 100%
    );
    animation: referred-skeleton-shimmer 1.4s ease-in-out infinite;
  }

  .skeleton-block {
    background-color: #e5e7eb;
  }

  .skeleton-filter {
    height: 3.5rem;
    border-radius: 0.75rem;
  }

  .skeleton-barcode-btn {
    width: 3.5rem;
    height: 3.5rem;
    border-radius: 0.75rem;
    flex-shrink: 0;
  }

  .skeleton-barcode-btn-sm {
    width: 3.25rem;
    height: 3.25rem;
    border-radius: 0.5rem;
    flex-shrink: 0;
  }

  .skeleton-search-full {
    height: 3.5rem;
    border-radius: 0.75rem;
  }

  .skeleton-req-card {
    min-height: 14rem;
    border-radius: 0.75rem;
  }

  @keyframes referred-skeleton-shimmer {
    100% {
      transform: translateX(100%);
    }
  }

  .request-lightbox {
    z-index: 999;
    touch-action: none;
    cursor: zoom-out;
  }

  .request-lightbox__stage {
    max-height: calc(100vh - 8rem);
    max-width: 100%;
  }

  .request-lightbox__img {
    touch-action: none;
  }
</style>
